import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { MdModeEditOutline } from "react-icons/md";
import DeleteIcon from '@mui/icons-material/Delete';

interface ActionButtonsProps {
    onEdit?: () => void;
    onDelete?: () => void;
    isEditEnabled?: boolean;  // New prop to control edit button state
    isDeleteEnabled?: boolean; // New prop to control delete button state
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
    onEdit,
    onDelete,
    isEditEnabled = true,
    isDeleteEnabled = true,
}) => (
    <div className="flex space-x-2">
        {onEdit && (
            <Tooltip title={isEditEnabled ? "Edit" : "Edit Disabled"}>
                <IconButton
                    onClick={isEditEnabled ? onEdit : undefined} // Disable click if not enabled
                    className="transition duration-300 ease-in-out transform "
                    style={{
                        color: isEditEnabled ? 'black' : 'lightgray', // Change icon color based on state
                    }}
                    disabled={!isEditEnabled} // Disable the button
                >
                    <MdModeEditOutline style={{ fontSize: "1.2rem" }} /> {/* Medium icon size */}
                </IconButton>
            </Tooltip>
        )}
        {onDelete && (
            <Tooltip title={isDeleteEnabled ? "Delete" : "Delete Disabled"}>
                <IconButton
                    onClick={isDeleteEnabled ? onDelete : undefined} // Disable click if not enabled
                    className="transition duration-300 ease-in-out transform p-1.5"
                    style={{
                        color: isDeleteEnabled ? 'black' : 'lightgray', // Change icon color based on state
                    }}
                    disabled={!isDeleteEnabled} // Disable the button
                >
                    <DeleteIcon style={{ fontSize: "1.2rem" }} /> {/* Medium icon size */}
                </IconButton>
            </Tooltip>
        )}
    </div>
);

export default ActionButtons;
